import SectionHeading from "@/components/feature/SectionHeading";
import { testimonials } from "@/mocks/site";

export default function Voices() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="COMMUNITY"
        title="吃瓜er怎么说"
        desc="我们更在意长期读下去的感受：看得快、看得全，也看得明白。"
      />
      <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-3">
        {testimonials.map((t) => (
          <figure
            key={t.name}
            className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-6"
          >
            <i className="ri-double-quotes-l text-3xl text-accent-500"></i>
            <blockquote className="mt-4 flex-1 text-sm leading-7 text-foreground-700">
              {t.quote}
            </blockquote>
            <figcaption className="mt-6 flex items-center gap-3 border-t border-background-200 pt-4">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-100 font-heading text-base font-black text-secondary-800">
                {t.name.slice(0, 1)}
              </span>
              <span className="flex flex-col">
                <span className="text-sm font-medium text-foreground-950">{t.name}</span>
                <span className="text-xs text-foreground-500">{t.role}</span>
              </span>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}